// extracted by mini-css-extract-plugin
module.exports = {"mdvPlansHeaderWrapper":"mdvPlanHeaderWrapper_mdvPlansHeaderWrapper__1Pxsm"};